<template>
<div class=radio_item>
  
            <label for=""
              >{{field.label}}</label
            >
            <ul>
              <li v-for="(item, index) in field.choices" :key="index"  :class="item.value==value ? 'active' : ''">
                <label :for="item.name"
                  >
                  <span class="radio_input"><input
                    type="radio"
                    :name="field.id"
                    :value="item.value"
                    :checked="item.value==value"
                    v-on:change="changeValue(item.value)"
                  /> <hr /> </span>
                  <span>{{item.label}}</span></label
                >
              </li>
            </ul>
</div>
</template>

<script>

export default {
  props: {
    field:Object,
    updateFormData:Function,
    index:Number,
    fields:Object,
  },
  data(){
    return {
      value:this.field.value,
    }
  },methods:{
    changeValue:function(value){
      let f = this.fields;
      this.value = value;
      
      f[this.index].value = value;
      this.updateFormData(f);
    }
  }
}
</script>


<style src="@vueform/slider/themes/default.css"></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.radio_item{
  padding: 20px 0px;
}
.radio_item label{
  padding: 10px 0px;
  display: flex;
    align-items: center;
  font-family: "Roboto Slab", serif;
}
ul li ul{
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  justify-content: space-between;
}
ul li ul li{
    min-width:25%;
}
.radio_input{
position: relative;
border-radius: 100%;
border: 1px solid #505050;
margin-right: 10px;
width: 20px;
height: 20px;
  cursor: pointer;
}
ul li ul li label span{

  cursor: pointer;
}
.radio_input input{
  opacity: 0;
}
.radio_input:after{

}
.radio_input input + hr{    background: #ef8e45;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    border: 0 none;
    margin: 2px;
    padding: 0;
    border-radius: 100%;
    width: auto;
    height: auto;
    opacity: 0;
}
.radio_input input:checked + hr{    background: #ef8e45;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    border: 0 none;
    margin: 2px;
    padding: 0;
    border-radius: 100%;
    width: auto;
    height: auto;
    opacity: 1;

}
.active label{
color:#ef8e45;
}
.radio_input:before{

}

@media all and (max-width: 600px) {
  .radio_item ul{
    
    flex-direction: column;
  }
}
</style>
